<!-- root backdrop -->

@if (tour.isActive()) {
  <div
    (click)="handleOutside()"
    class="fixed inset-0 z-[9998] bg-black/50"
  ></div>
}
<!-- floating card -->
<!-- floating card ------------------------------------------------->
@if (tour.isActive()) {
  <div
    class="fixed z-[9999] select-none"
    [style.top]="cardPos().top"
    [style.left]="cardPos().left"
    [style.width]="activeStep().width ?? '18rem'"
    >
    <div class="relative bg-white p-4 shadow-xl">
      <!-- 🞄 ARROW (rotated square) -->
      <span
        [ngClass]="arrowClass"
        class="absolute w-4 h-4 rotate-45 bg-white ring-black/10"
      ></span>
      <h3 class="mb-3 text-base font-semibold text-dc-navy">
        {{ activeStep().titleKey | translate }}
      </h3>
      <p
        class="mb-6 whitespace-pre-line text-sm text-slate-700!"
        [innerHTML]="activeStep().bodyKey | translate"
      ></p>
      <div class="flex items-center justify-between w-full">
        <!-- step number -->
        <p class="font-semibold text-dc-black!">
          {{ tour.currentIndex() + 1 }}/{{ stepsSize() }}
        </p>
        <!-- next / done button -->
        <app-button
          type="button"
          classesName="card-edge-cut-white ml-auto min-w-30"
        [label]="
          tour.currentIndex() + 1 === stepsSize()
            ? ('TOUR.DONE' | translate)
            : ('TOUR.NEXT' | translate)
        "
          (onBtnClick)="tour.next()"
          >
        </app-button>
      </div>
    </div>
  </div>
}
